import { useQueryErrorResetBoundary } from '@tanstack/react-query';
import { ErrorBoundary } from 'react-error-boundary';
import React from 'react';
import ErrorScreen from '../../core-components/theme/components/ErrorScreen';

interface CustomFallbackProps {
    error: Error;
    onRetry: () => void;
}

interface QueryErrorBoundaryProps {
    children: React.ReactNode;
    fallback?: React.ComponentType<CustomFallbackProps>;
}

export default function QueryErrorBoundary({
    children,
    fallback: FallbackComponent = ErrorScreen,
}: QueryErrorBoundaryProps) {
    const { reset } = useQueryErrorResetBoundary();

    return (
        <ErrorBoundary
            onReset={reset}
            fallbackRender={({ resetErrorBoundary, error }) => (
                <FallbackComponent error={error} onRetry={resetErrorBoundary} />
            )}
        >
            {children}
        </ErrorBoundary>
    );
}